import { createAction, props } from '@ngrx/store';
import {
  ClientConfig,
  DataPrivacyConfig,
  UserInfo,
} from '../reducers/session-info.reducer';

export enum SessionInfoActions {
  UserInfoFetched = '[Session/Info] UserInfo fetched',
  ClientConfigFetched = '[Session/Info] ClientConfig fetched',
  IsNativeClientDefined = '[Session/Info] It is defined Native client or not',
  DataPrivacyConfigFetched = '[Session/Info] DataPrivacyConfig fetched',
  BookedAppointments = '[Session/Info] Booked appointments fetched',
}

export const userInfoFetched = createAction(
  SessionInfoActions.UserInfoFetched,
  props<{
    userInfo: UserInfo;
  }>(),
);

export const clientConfigFetched = createAction(
  SessionInfoActions.ClientConfigFetched,
  props<{
    clientConfig: ClientConfig;
  }>(),
);

export const isNativeClientDefined = createAction(
  SessionInfoActions.IsNativeClientDefined,
  props<{
    isNativeClient: boolean;
  }>(),
);

export const dataPrivacyConfigFetched = createAction(
  SessionInfoActions.DataPrivacyConfigFetched,
  props<{
    dataPrivacyConfig: DataPrivacyConfig;
  }>(),
);
export const bookedAppointments = createAction(
  SessionInfoActions.BookedAppointments,
  props<{
    appointments;
  }>(),
);
